import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PlayGameView from './components/play-game-view/PlayGameView'

import { 
    finishMyTurn,
    getBagSize, 
    getGrid, 
    getHandTiles, 
    getIsMyTurn, 
    getPlacedTiles, 
    getPlayers,
    getTradedTiles,
    placeTile,
    resetMyTurn,
    takeBackTile,
    tradeTile
} from './gameSlice'

export default function PlayGameContainer() {
    const dispatch = useDispatch()

    const players = useSelector(getPlayers)
    const grid = useSelector(getGrid)
    const bagSize = useSelector(getBagSize)
    const isMyTurn = useSelector(getIsMyTurn)
    const handTiles = useSelector(getHandTiles)
    const placedTiles = useSelector(getPlacedTiles)
    const tradedTiles = useSelector(getTradedTiles)

    const canTrade = isMyTurn && bagSize > 0 && placedTiles.length === 0
    const canPlace = isMyTurn && tradedTiles.length === 0
    const canReset = tradedTiles.length !== 0 || placedTiles.length !== 0
    const canSubmit = canReset

    const handleTrade = useCallback(({ tileId }) => {
        dispatch(tradeTile({ id: tileId }))
    }, [dispatch])
    const handlePlace = useCallback(({ row, col, tileId }) => {
        dispatch(placeTile({ row, col, id: tileId }))
    }, [dispatch])
    const handleTakeBack = useCallback(({ tileId }) => {
        dispatch(takeBackTile({ id: tileId }))
    }, [dispatch])
    const handleReset = useCallback(() => dispatch(resetMyTurn()), [dispatch])
    const handleSubmit = useCallback(() => dispatch(finishMyTurn()), [dispatch])

    return (
        <PlayGameView
            players={players}
            grid={grid}
            bagSize={bagSize}
            isMyTurn={isMyTurn}
            handTiles={handTiles}
            canTrade={canTrade}
            canPlace={canPlace}
            canReset={canReset}
            canSubmit={canSubmit}
            onTrade={handleTrade}
            onTakeBack={handleTakeBack}
            onPlace={handlePlace}
            onReset={handleReset}
            onSubmit={handleSubmit}
        />
    )
}
